module.exports = __webpack_public_path__ + "static/media/Gotham-Bold.49169099.otf";


//////////////////
// WEBPACK FOOTER
// ./public/assets/fonts/Gotham Fonts/Gotham-Bold.otf
// module id = 1320
// module chunks = 0